import React from 'react';

const UserContext = React.createContext<any>(undefined);

export default UserContext;